import { learnerPortalInfoApi } from "./_learnerActions";

const CACHE_PREFIX = "lmsPortalInfo:";
const CACHE_TTL_MS = 30 * 60 * 1000;
const memoryCache = new Map();
const pendingRequests = new Map();

const cacheKey = (lmsShortName = "") => `${CACHE_PREFIX}${String(lmsShortName).toLowerCase()}`;

export const getCachedPortalInfo = (lmsShortName) => {
  if (!lmsShortName) return null;
  const key = cacheKey(lmsShortName);
  const memoryValue = memoryCache.get(key);
  if (memoryValue?.expiresAt > Date.now()) return memoryValue.data;

  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.expiresAt > Date.now()) {
      memoryCache.set(key, parsed);
      return parsed.data;
    }
    sessionStorage.removeItem(key);
  } catch {
    sessionStorage.removeItem(key);
  }
  return null;
};

export const setCachedPortalInfo = (lmsShortName, data) => {
  if (!lmsShortName || !data) return;
  const key = cacheKey(lmsShortName);
  const value = { data, expiresAt: Date.now() + CACHE_TTL_MS };
  memoryCache.set(key, value);
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage can fail in private windows; memory cache still prevents route flicker.
  }
};

export const loadPortalInfoCached = async (lmsShortName) => {
  const cached = getCachedPortalInfo(lmsShortName);
  if (cached) return cached;

  const key = cacheKey(lmsShortName);
  if (pendingRequests.has(key)) return pendingRequests.get(key);

  const request = learnerPortalInfoApi({ lmsShortName })
    .then((res) => {
      const { status, data } = res?.data || {};
      if (status === 200 && data) {
        setCachedPortalInfo(lmsShortName, data);
        return data;
      }
      return null;
    })
    .finally(() => pendingRequests.delete(key));

  pendingRequests.set(key, request);
  return request;
};
